
export const useQuery = () => {
    const params =
        typeof window !== "undefined"
            ? new URLSearchParams(window.location.search)
            : new URLSearchParams();

    const get = (name: string) => {
        const lower = name.toLowerCase();
        for (const [key, value] of params.entries()) {
            if (key.toLowerCase() === lower) return value;
        }
        return null;
    };

    return { get };
};